import { request } from './request';

export const getSynonymDictionaries = () => request('/airtable/dictionaries', 'GET');
